import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import EditLeaveRequestComp from '../../components/version-4/MasterForms/EditForms/EditLeaveRequestComp'
import { useLeave } from '../../hooks/Features/useLeaves'
import { ROUTES } from '../../shared/constants'

export default function EditLeaveRequest() {
  const { loading, leave, getLeaveRequest, editLeaveRequest } = useLeave()
  const params = useParams()
  const [leaveData, setLeaveData] = useState({
    leaveStatus: '',
    from: '',
    to: '',
  })

  React.useEffect(() => {
    getLeaveRequest({ leaveId: params.leaveId })
  }, [params.leaveId])

  React.useEffect(() => {
    if (leave) {
      setLeaveData({
        leaveStatus: leave.leaveApproved,
        from: leave.leaveFrom,
        to: leave.leaveTo,
      })
    }
  }, [leave])

  const handleZone = () => {
    editLeaveRequest({ ...leaveData, leaveId: params.leaveId })
  }
  return (
    <Layout heading="Leave Request" heading2="Edit" url1={ROUTES.LEAVE_REQUESTS} none>
      {!loading ? (
        <HeaderTabLayout
          heading="Edit Leave Request"
          content={<EditLeaveRequestComp state={leaveData} setState={setLeaveData} />}
          addContent={handleZone}
          state={leaveData} setState={setLeaveData} 
          redirect={ROUTES.LEAVE_REQUESTS}
        />
      ) : (
        <Loader />
      )}
    </Layout>
  )
}
